<template>
  <div>
  <v-card>
    <!-- grey background -->
    <v-progress-linear
      color="grey lighten-1"
      rounded
      height="10"
      style="position: absolute;"
    />
  </v-card>
  <v-progress-linear
    :active="!!goal.target_amount"
    height="10"
    rounded
    :buffer-value="buffer"
    :value="success ? buffer : value"
    color="green"
    background-color="green lighten-3"
  />
  </div>
</template>

<script>
export default {
  props: ['goal', 'amount', 'success'],
  computed: {
    value (){
      return parseInt((this.goal.starting_amount / this.goal.target_amount) * 100)
    },
    userAmount (){
      return parseFloat(this.amount) + parseFloat(this.goal.starting_amount)
    },
    buffer (){
      return parseInt((this.userAmount / this.goal.target_amount) * 100)
    }
  }

}
</script>